import { DEPLOYMENT_ENV as ENV } from '@futrli/shared-services';

import { DEPLOYMENT_ENV } from '../core/config';

export const isDevEnvironment = (): boolean => DEPLOYMENT_ENV === ENV.DEVELOPMENT;
export const isProdEnvironment = (): boolean => DEPLOYMENT_ENV === ENV.PRODUCTION;
